import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProfileSelectorComponent } from '@com-delta-idp/mnx-capability-profile-selector-smart';
import { LoginModalModule } from '../login-modal/login-modal.module';
import { LoginModalWrapperComponent } from './login-modal-wrapper.component';

@NgModule({
  declarations: [LoginModalWrapperComponent],
  imports: [CommonModule, LoginModalModule, ProfileSelectorComponent],
  exports: [LoginModalWrapperComponent]
})
export class LoginModalWrapperModule {}
